import * as React from 'react';
import moment from 'moment-timezone';
import classNames from 'classnames';
import './paymentView.module.scss';
import { PaymentIndexView } from '../../../types/payments';
import { PaymentStatusView } from './PaymentStatusView';
import { PaymentMethodView } from './PaymentMethodView';
import { routingStore } from '../../../../common/stores/routing';
import { V3Routes } from '../../../routes';
import { BodyText, Button, LabelText } from '@sheinc/shelikes-design-system';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

type Props = {
  payment: PaymentIndexView;
  showAction?: boolean;
};

const isSp = GlobalStatesV3.viewport.isSp;

export class PaymentView extends React.Component<Props> {
  render() {
    const { payment, showAction = true } = this.props;
    return (
      <div styleName="payment-history" className="payment-history">
        <div styleName="col title">
          <BodyText size="M">{payment.order_title}</BodyText>
        </div>
        <div styleName={classNames('col detail')}>
          <table>
            <tbody>
              <tr>
                <th>
                  <LabelText color="weak" size="S">
                    決済状況
                  </LabelText>
                </th>
                <td>
                  <PaymentStatusView paymentStatus={payment.status} />
                </td>
              </tr>
              <tr>
                <th>
                  <LabelText color="weak" size="S">
                    支払い日
                  </LabelText>
                </th>
                <td>
                  <LabelText size="M">{moment(payment.paid_at).format('YYYY/MM/DD')}</LabelText>
                </td>
              </tr>
              <tr>
                <th>
                  <LabelText color="weak" size="S">
                    お支払方法
                  </LabelText>
                </th>
                <td>
                  <BodyText lineHeight="tight" size="S">
                    <PaymentMethodView paymentMethod={payment.payment_method} />
                  </BodyText>
                </td>
              </tr>
              <tr>
                <th>
                  <LabelText color="weak" size="S">
                    金額
                  </LabelText>
                </th>
                <td>
                  <LabelText size="M">
                    {payment.amount.toLocaleString('ja-JP', {
                      style: 'currency',
                      currency: 'JPY',
                    })}
                  </LabelText>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {showAction && (
          <div styleName="col action">
            {payment.status == 'paid' && (
              <Button
                variant="secondary"
                size="small"
                onClick={() => routingStore.push(V3Routes.generate_receipt(payment.code))}
                fullWidth={isSp}
              >
                領収書
              </Button>
            )}
            {payment.status == 'error' && (
              <Button
                variant="danger"
                size="small"
                onClick={() => routingStore.push(V3Routes.retry_payment(payment.code))}
                fullWidth={isSp}
              >
                再支払いする
              </Button>
            )}
          </div>
        )}
      </div>
    );
  }
}
